import { CellContext } from '@tanstack/react-table'

import { Switch } from 'components/Switch'
import { useUpdateWorkspaceBidder } from 'features/globalSetup/pages/Prebid/Bidders/hooks/useUpdateWorkspaceBidder'
import { useAbility } from 'providers/casl'
import { generateSelector } from 'providers/product-fruits/utils'
import { BiddersForTable } from '../../types'

export const EnabledCell = ({
  getValue,
  row: {
    index,
    original: { accountType, code: bidderCode, id, status },
  },
}: CellContext<BiddersForTable, unknown>): React.JSX.Element => {
  const ability = useAbility()
  const disabled =
    (accountType === 'yieldbird' && status !== 'available') ||
    ability.cannot('update', 'GlobalSetupFeature-bidder')

  const { checked, update } = useUpdateWorkspaceBidder({
    bidderCode,
    enabled: Boolean(getValue()),
    id,
  })

  return (
    <Switch
      checked={checked}
      data-product-fruits={
        index === 0 ? generateSelector({ step: 5, subTour: 2, tour: 3 }) : undefined
      }
      disabled={disabled}
      onChange={update}
    />
  )
}
